import React from 'react';
import { Box, Typography } from '@mui/material';
import { relativeDue, shortDate } from '../helpers';
import { launchColors, scheduleStatusStyle } from '../launchTheme';
import { ScheduleStatus } from '../types';

interface Props {
  due: string | null;
  asOf: string;
  status: ScheduleStatus;
  align?: 'left' | 'right';
}

const DueLabel: React.FC<Props> = ({ due, asOf, status, align = 'left' }) => {
  const style = scheduleStatusStyle[status];
  const relative = status === 'complete' ? 'klar' : relativeDue(due, asOf);
  const emphasised = status === 'overdue' || status === 'at_risk' || status === 'due_soon';
  return (
    <Box sx={{ textAlign: align, minWidth: 0 }}>
      <Typography component="span" sx={{ fontSize: 13, fontWeight: 600, color: due ? launchColors.text : launchColors.textSecondary, fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}>
        {due ? shortDate(due, asOf) : 'Datum saknas'}
      </Typography>
      {due && (
        <Typography component="span" sx={{ fontSize: 12, fontWeight: emphasised ? 700 : 500, color: emphasised ? style.fg : launchColors.textSecondary, whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }}>
          {` · ${relative}`}
        </Typography>
      )}
    </Box>
  );
};

export default DueLabel;
